import { styled as muiStyled } from '@mui/material'
import { TimeField } from '@mui/x-date-pickers'

export const MuiRangeTimerTimeClockInput = muiStyled(TimeField)(
  ({ theme, isTimeInvalid }) => `
  width:100%;
    .MuiFormLabel-root {
      display: none;
    }
    .MuiOutlinedInput-notchedOutline{
      display:none;
    }
    .MuiInputBase-input {
      color: ${isTimeInvalid ? '#ff6666' : '#fff'};
      width: 100%;
      text-align:center;
      font-size: 1.5rem;
      padding:0;
      font-family: "Roboto Mono", monospace;
    }
  `,
)
